<template>
    <div>
        <skeleton-loader v-if="loading" type="rows" :count="4" />
        <template v-else>
            <div v-if="files.length === 0 && !isCoach" class="archivos-empty">
                {{ $t('common.no_files') }}
            </div>
            <div v-else class="file-list">
                <div class="file-item" v-for="file in files" :key="file.id" v-ripple @click="onItemClick(file)">
                    <span class="file-name">{{ file.name }}</span>
                    <button-tooltip icon x-small top :tooltip="$t('common.download')" buttonClass="file-download"
                        @click="downloadFile(file, $event)">
                        <v-icon size="18" color="accent">mdi-download</v-icon>
                    </button-tooltip>
                </div>
                <div v-if="files.length === 0" class="archivos-empty">{{ $t('common.no_files') }}</div>

                <button v-if="isCoach && !headerAdd && files.length < 5" type="button" class="file-add"
                    @click="showAddFile">
                    <v-icon size="20" color="accent">$plus</v-icon>
                </button>
            </div>
        </template>

        <files-student-dialog ref="files" @saved="loadFiles" :student-id="studentId" :coach-id="coachId" />
    </div>
</template>

<script>
import { Browser } from '@capacitor/browser'
import { db } from "@/utils/Firebase";
import SkeletonLoader from '../common/SkeletonLoader.vue';
import FilesStudentDialog from './FilesStudentDialog.vue';
import ButtonTooltip from '../common/ButtonTooltip.vue';
export default {
    components: { SkeletonLoader, FilesStudentDialog, ButtonTooltip },
    name: "FilesStudentSection",
    props: {
        studentId: {
            type: String,
            default: null,
        },
        coachId: {
            type: String,
            default: null,
        },
        headerAdd: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            files: [],
        }
    },
    computed: {
        isCoach(vm = this) {
            return vm.accountType === 'coach' || vm.accountType === 'company'
        },
    },
    mounted() {
        const vm = this;
        vm.loadFiles()
    },
    methods: {
        async loadFiles() {
            const vm = this;
            vm.loading = true

            const filesRef = await db.collection('studentFiles')
                .where('coachId', '==', vm.coachId)
                .where('studentId', '==', vm.studentId)
                .orderBy('createdAt', 'desc')
                .get()

            vm.files = filesRef.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }))

            vm.$emit('count', vm.files.length)
            vm.loading = false
        },
        showAddFile() {
            this.$refs.files.show()
        },
        onItemClick(file) {
            const vm = this
            if (vm.isCoach) vm.editFile(file)
            else vm.downloadFile(file)
        },
        editFile(file) {
            this.$refs.files.setDefaults(file)
        },
        async downloadFile(file, event) {
            if (event) event.stopPropagation()
            try {
                const url = file.url
                await Browser.open({ url, presentationStyle: 'popover' })
            } catch (err) {
                console.error(err)
                this.toast(this.$t('common.download_error'), 'error')
            }
        }
    }
}
</script>

<style scoped>
.archivos-empty {
    padding: 20px;
    text-align: center;
    font-size: 13px;
    color: var(--v-txtMuted-base);
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 12px 14px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s;
}

.file-item:hover {
    background: var(--v-outline-base);
}

.file-name {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    word-break: break-word;
}

.file-list >>> .file-download {
    width: 34px !important;
    height: 34px !important;
    border-radius: 50% !important;
    border: 1px solid var(--v-outline2-base) !important;
    background: var(--v-surface-base) !important;
    flex-shrink: 0;
    transition: background 0.15s, border-color 0.15s;
}

.file-list >>> .file-download:hover {
    background: rgba(51, 153, 153, 0.15) !important;
    border-color: var(--v-accent-base) !important;
}

.file-add {
    align-self: flex-start;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface-base);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    transition: background 0.15s;
}

.file-add:hover {
    background: var(--v-surface2-base);
}
</style>